import {
  Button,
  Collapse,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import FilterListIcon from "@material-ui/icons/FilterList";
import SendIcon from "@material-ui/icons/Send";
import { POSITION_TELESALE } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  DATE_SORT_OPTIONS,
  DATE_TYPE_SUGGEST,
  HAS_IMG,
  LAServiceRequestItemStatusEnum,
} from "app/common/LocalConst";
import SelectPagingCheckBoxDetail from "app/PatientManagement/ReportPayment/Component/SelectPagingCheckBoxDetail";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingHealthCareRoom } from "app/services/HealthCareRoomService";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { pagingStaff } from "app/services/StaffService";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useState } from "react";
import { filterBaseOptions } from "utils";

const ConstructionMaterialsSynthesisSearch = ({
  isAdminRole,
  departmentsUser,
  handleOpenRequestStoreConstructionMaterialPopup,
  listSelected,
}) => {
  const { values, setFieldValue, touched, errors } = useFormikContext();

  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const department = useDefaultDepartment();
  return (
    <>
      <div className="cards-header">
        <h4>Bộ lọc tìm kiếm</h4>
      </div>

      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tìm kiếm"
            placeholder="Tìm kiếm theo dịch vụ/mã/tên/SĐT khách hàng..."
            name="keyword"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            name={"performer"}
            label={"Người thực hiện"}
            api={pagingStaff}
            searchObject={{
              isActive: true,
            }}
            getOptionLabel={(option) => option?.staffName || ""}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsStaff(option)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsMultiDatePicker
            label="Thời gian chỉ định từ - đến ngày"
            name="orderDateFrom"
            range
            rangeHover
            fromField="orderDateFrom"
            toField="orderDateTo"
          // format={"DD/MM/YYYY"}
          />
          {touched.orderDateTo && errors.orderDateTo && (
            <div style={{ color: "red", fontSize: 12 }}>
              {errors.orderDateTo}
            </div>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={6} className="flex flex-end gap-2">
          {listSelected?.length > 0 && (
            <Button
              className="btn-primary"
              onClick={() => {
                handleOpenRequestStoreConstructionMaterialPopup({
                  department: values?.department || department,
                });
              }}
            >
              <SendIcon />
              Tạo phiếu xuất kho
            </Button>
          )}
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>

          <CommonButton
            className="btn-filter"
            color={"white"}
            onClick={() => setOpen((prev) => !prev)}
          >
            <FilterListIcon color="red" />

            {!isMobile && "Bộ lọc nâng cao"}
          </CommonButton>
        </Grid>

        <Grid item xs={12}>
          <Collapse in={open}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={"assigner"}
                  label={"Người chỉ định"}
                  api={pagingStaff}
                  searchObject={{ isActive: true }}
                  getOptionLabel={(option) => {
                    return option?.staffName || "";
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={"currentTelesaleIds"}
                  label={"Telesale hiện thời"}
                  api={pagingStaff}
                  getOptionLabel={(option) => option?.staffName || ""}
                  searchObject={{
                    positionCode: POSITION_TELESALE,
                    isActive: true,
                  }}
                  multiple
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsPagingAutocomplete
                  api={pagingCustomerSource}
                  name={"patientSourceIds"}
                  label="Nguồn đầu tiên"
                  multiple
                  filterOptions={filterBaseOptions}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsPagingAutocomplete
                  api={pagingCustomerSource}
                  name={"currentPatientSourceIds"}
                  label="Nguồn hiện tại"
                  multiple
                  filterOptions={filterBaseOptions}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsMultiDatePicker
                  label="Thời gian thực hiện từ - đến ngày"
                  name="performDateFrom"
                  range
                  rangeHover
                  fromField="performDateFrom"
                  toField="performDateTo"
                // format={"DD/MM/YYYY"}
                />
                {touched.performDateTo && errors.performDateTo && (
                  <div style={{ color: "red", fontSize: 12 }}>
                    {errors.performDateTo}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <SelectPagingCheckBoxDetail
                  name={"listDepId"}
                  label={"Cơ sở"}
                  api={
                    isAdminRole
                      ? pagingDepartment
                      : async () => ({
                        data: { content: departmentsUser || [] },
                      })
                  }
                  listSelected={values?.listDepId || []}
                  setListOption={(listDepId) => {
                    setFieldValue("listDepId", listDepId);
                  }}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  name="minAmountPaid"
                  label="Cần thu từ"
                  placeholder="Nhập số tiền"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  name="maxAmountPaid"
                  label="Cần thu đến"
                  placeholder="Nhập số tiền"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  name="minTotalBill"
                  label="Đã thu từ"
                  placeholder="Nhập số tiền"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  name="maxTotalBill"
                  label="Đã thu đến"
                  placeholder="Nhập số tiền"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name="room"
                  label="Phòng"
                  searchObject={{
                    departmentIds:
                      values?.departmentIds?.map((el) => el?.id) || [], // dùng mảng thay vì 1 id
                    isUse: true,
                  }}
                  api={pagingHealthCareRoom}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  name={"healthCareSv"}
                  label={"Dịch vụ"}
                  searchObject={{
                    isUsing: true,
                  }}
                  api={pagingHealthCareService}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsSelectInput
                  name="itemStatus"
                  options={LAServiceRequestItemStatusEnum.getListData()}
                  label="Trạng thái điều trị"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsSelectInput
                  options={HAS_IMG}
                  label="Trạng thái up ảnh"
                  name="hasImg"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsSelectInput
                  options={DATE_TYPE_SUGGEST}
                  label={"Loại ngày lọc theo"}
                  name="dateInconsistencyType"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsSelectInput
                  options={DATE_SORT_OPTIONS}
                  label={"Sắp xếp theo ngày chỉ định"}
                  name="orderByDateFrom"
                />
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(ConstructionMaterialsSynthesisSearch));
